import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const PersonActiveIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 32 32"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <circle cx={16} cy={10} r={6} fill="#EBEAFD" />
            <path fill="#EBEAFD" d="M16 16c-5.523 0-10 4.03-10 9 0 0 1.5 3 10 3s10-3 10-3c0-4.97-4.477-9-10-9Z" />
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 10a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"
            />
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5.773 26c0-2.74 1.089-5.175 3.026-7.112C10.736 16.951 13.26 16 16 16c2.74 0 5.471.95 7.408 2.888 1.938 1.937 2.819 4.372 2.819 7.112M6 26s3.5 2 10 2 10-2 10-2"
            />
        </svg>
    </IconWrapper>
)
